import { z } from "zod";
import { createStorageStore } from "../../../utils/createStore.ts";
import { useUser } from "../../hooks/useUser.ts";

const zLastSelectedWorkspaceUuid = z.object({
  uuid: z.string().optional(),
});

export const useLastSelectedWorkspaceUuidStore = createStorageStore(
  localStorage,
  "last-selected-workspace-uuid-v2",
  z.record(zLastSelectedWorkspaceUuid),
  {},
  ({ update }) => ({
    updateLastSelectedWorkspaceUuid: ({
      userUuid,
      workspaceUuid,
    }: {
      userUuid: string;
      workspaceUuid: string;
    }) => {
      update((draft) => {
        draft[userUuid] = { uuid: workspaceUuid };
      });
    },
    resetLastSelectedWorkspaceUuid: ({ userUuid }: { userUuid: string }) => {
      update((draft) => {
        draft[userUuid] = { uuid: undefined };
      });
    },
  }),
);

export const useLastSelectedWorkspaceUuid = () => {
  const { user } = useUser();

  const lastSelectedWorkspaceUuidStore =
    useLastSelectedWorkspaceUuidStore.useState();

  return user && user.uuid in lastSelectedWorkspaceUuidStore
    ? lastSelectedWorkspaceUuidStore[user.uuid].uuid
    : undefined;
};
